<template src="@/templates/document/policyDocuments.html"></template>

<script>
import { mapActions } from "vuex";
import PolicyDocumentsCollection from "@/collections/policyDocumentsCollection";
import PolicyDocumentsModel from "@/models/policyDocumentsModel";
import fileView from "@/components/file/FileView";

export default {
  name: "policyDocuments",
  components: {
    fileView,
  },
  data() {
    return {
      policyDocumentsCollection: new PolicyDocumentsCollection(),
      policyDocumentsModel: new PolicyDocumentsModel(),
      viewFileViewComp: false,
      policy_document_id: 0,
      currentFileName: "",
      isThis: "policyDocuments",
    };
  },
  created() {
    this.updateHideAll();
    this.updateBackButton(false);
    this.getPolicyDocumentList();
  },
  mounted() {
    Event.$on("hideFileViewComp", (isThis) => {
      if (isThis === this.isThis) {
        let thisComponent = this;
        setTimeout(function () {
          thisComponent.viewFileViewComp = false;
          thisComponent.getPolicyDocumentList();
        }, 50);
      }
    });
  },
  methods: {
    ...mapActions(["updateHideAll", "updateBackButton"]),
    getPolicyDocumentList() {
      this.policyDocumentsCollection
        .getList()
        .then((PDCollectionRes) => {
          this.policyDocumentsCollection.models =
            PDCollectionRes.response.data.data;
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    getPolicyDocument(model) {
      this.policyDocumentsModel.data.policy_document_id =
        model.policy_document_id;

      this.policyDocumentsModel
        .saveAsRead()
        .then()
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });

      this.viewFileViewComp = true;
    },
  },
};
</script>

<style scoped>
.con-vs-dialog {
  z-index: 40001 !important;
}

.badge {
  color: white;
  background-color: #f57e21;
}
</style>
